export const CONTRACT_STEPS = ["Upload", "Signatários"];
